import { render, staticRenderFns } from "./SessionManager.vue?vue&type=template&id=7952e515&scoped=true"
import script from "./SessionManager.vue?vue&type=script&lang=js"
export * from "./SessionManager.vue?vue&type=script&lang=js"
import style0 from "./SessionManager.vue?vue&type=style&index=0&id=7952e515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7952e515",
  null
  
)

export default component.exports